import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <p class="mb-3 bold text-center">Alaŭdo</p>

    <div class="poem">
      <p class="poem-block mb-3">
        Inter tero kaj ĉiel’<br/>
        Sonas kanto trile,<br/>
        Sonas kvazaŭ sonoril’<br/>
        Laŭte kaj jubile.<br/>
        Ne videblas la birdet’,<br/>
        Alaŭdet’ sonora,<br/>
        Nur aŭdiĝas la kantet’<br/>
        El ĉielo fora.
      </p>

      <p class="poem-block mb-3">
        Kantas li por amikin’,<br/>
        Kanton portas vento.<br/>
        Kiam ĝi atingos ŝin, <br/>
        Flagros ŝia sento.<br/>
        Sonu, fluu, mia kant’,<br/>
        Kanto de l’ espero.<br/>
        Ĝin ekaŭdu la amant’<br/>
        Kun suspir’ sincera.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Mihail Glinka'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;